import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { TranslatableModel } from './translatable-model';

export class AddonSetting extends TranslatableModel {


    get RECURRING() {

        return 0;
    }

    get ONE_TIME() {

        return 1;
    }


    get ACTIVE() {

        return 1;
    }

    get NOT_ACTIVE() {

        return 0;
    }

    get CLASS_GENERAL (){

        return 0;
    }

    get CLASS_DEFAULT (){

        return 1;
    }

    get CLASS_SMS (){

        return 2;
    }

    get CLASS_OTA (){

        return 4;
    }

    static get CLASS_HOUSEKEEPING() {

        return 10;
    }

    static get CLASS_CASH_DRAWER() {

        return 11;
    }

    static get CLASS_ADD_ONS() {

        return 12;
    }

    static get CLASS_COMPLEMENTARY() {

        return 13;
    }

    static get CLASS_BOOKING_ENGINE() {

        return 14;
    }

    static get CLASS_OTA_BOOKING() {

        return 15;
    }

    static get CLASS_OTA_AGODA() {

        return 16;
    }

    static get CLASS_OTA_GTA() {

        return 17;
    }

    static get CLASS_OTA_EXPEDIA() {

        return 18;
    }

    static get STATIC_CLASS_SMS() {

        return 2;
    }

    static get CLASS_NTMP() {

        return 19;
    }

    static get CLASS_SHOMOOS() {

        return 20;
    }

    static get CLASS_PAYMENT_INTEGRATION() {

        return 21;
    }

    static get CLASS_CHANNEL_MANAGER() {

        return 22;
    }

    static get CLASS_BALADY() {

        return 23;
    }

    static get CLASS_ZATCA() {
        return 19;
    }

    get TYPES() {

        return {
            [this.RECURRING]: 'RECURRING',
            [this.ONE_TIME]: 'ONE_TIME',
        };
    }

    get STATUSES() {

        return {
            [this.ACTIVE]: 'ACTIVE',
            [this.NOT_ACTIVE]: 'INACTIVE',
        };
    }

    get stringFormatTypes() {

        return this.TYPES[this.type];
    }

    get stringFormatStatus() {

        return this.STATUSES[this.status];
    }

    getQuantitySms(value) {

        if (value) {

            return value;
        }

        if (this.pivot) {

            return this.pivot.sms_number;
        }

        return 0;
    }

    getQuantityRooms(value) {

        if (value) {

            return value;
        }

        if (this.pivot) {

            return this.pivot.room_number;
        }

        return 0;
    }

    isBase() {

        return this.class === this.CLASS_DEFAULT;
    }

    isSMSRelated() {

        return [
            this.CLASS_SMS,
            AddonSetting.CLASS_COMPLEMENTARY
        ].includes(this.class);
    }

    isChannelManager() {

        return this.class === AddonSetting.CLASS_CHANNEL_MANAGER;
    }

}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'name_ar',
    'type',
    'monthly',
    'annual',
    'status',
    'pivot',
    'quantity_sms',
    'quantity_rooms',
    'class',
    'coupons',
    'monthly_price_with_vat',
    'annual_price_with_vat',
    'total_price',
)(AddonSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/addon-setting.model.js